import {cloneForm} from './form-helpers';

let cache;

export async function getExampleForms() {
  if (cache) {
    return cache;
  }

  const request = await fetch('/examples/index.json');

  if (!request.ok) {
    return [];
  }

  const categories = await request.json().catch(() => []);
  const requests = categories
    .map(async category => {
      const request = await fetch(`/examples/${category.path}/index.json`);

      if (!request.ok) {
        return null;
      }

      const files = await request.json().catch(() => []);
      const forms = (await Promise.all(files.map(async file => {
        const request = await fetch(`/examples/${category.path}/${file}`);

        if (!request.ok) {
          return null;
        }

        const form = await request.json().catch(() => null);

        if (!form) {
          return null;
        }

        return {file, form};
      }))).filter(Boolean);

      if (forms.length < 1) {
        return null;
      }

      return {
        ...category,
        forms
      };
    });

  cache = (await Promise.all(requests)).filter(Boolean);
  return cache;
}

export function convertExample(form, currentUser) {
  const newForm = cloneForm(form.name, form);

  return {
    ...newForm,
    alerts: newForm.alerts.map(alert => ({
      ...alert,
      alertContacts:[currentUser]
    }))
  };
}